import mainCaller from './mainCaller';

// 지점별 커스텀 옵션 (#93) — backend: /admin/api/v1/branch/{branchId}/custom-option
// 지금 쓰는 타입은 출결 기간 프리셋 하나뿐이고, 앞으로 종목·상담목적 등이 같은 API 를 탄다.

export async function getBranchCustomOptions(token, branchId, type) {
  return await mainCaller(
    `admin/api/v1/branch/${branchId}/custom-option?type=${type}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

export async function createBranchCustomOption(token, branchId, body) {
  return await mainCaller(
    `admin/api/v1/branch/${branchId}/custom-option`,
    'POST',
    body,
    { Authorization: `Bearer ${token}` },
  );
}

export async function deleteBranchCustomOption(token, branchId, optionId) {
  return await mainCaller(
    `admin/api/v1/branch/${branchId}/custom-option/${optionId}`,
    'DELETE',
    null,
    { Authorization: `Bearer ${token}` },
  );
}
